import React, { useState, useEffect } from "react"
import { CES2025 } from "../util/conditionalLinks"
import PoptinTwo from "./blocks/Forms/PopupForm"
import GitexPopupModal from "./core/GitexPopupModal"

const StickyHeader = () => {
  const [gitexPopup, setGitexPopup] = useState(false)
  // const handlePopup = () => {
  //   setGitexPopup(true)
  //   sessionStorage.setItem("GitexForm", true)
  // }
  const [openGitex, setOpenGitex] = useState(false)
  const [current, setCurrent] = useState()
  const openGitexModal = () => {
    setTimeout(() => {
      setOpenGitex(true)
    }, 1000)
  }
  const closeGitexModal = () => {
    setOpenGitex(false)
  }
  useEffect(() => {
    setCurrent(window.location.pathname)
  }, [])
  return (
    <>
      {CES2025.includes(current) && (
        <GitexPopupModal open={openGitex} closeGitexModal={closeGitexModal} />
      )}
      {gitexPopup && (
        <>
          <PoptinTwo setGitexPopup={setGitexPopup} />
        </>
      )}
      <div className="px-2 h-12 bg-yellow-500 flex-row flex justify-center items-center w-full">
      <div
        className="flex items-center cursor-pointer"
        onClick={openGitexModal}>
        <img
          src={"https://webmobtechcdn.nyc3.cdn.digitaloceanspaces.com/wmt_v4/2024/12/CES-logo.webp"} // Replace with the correct image path
          alt="CES Logo"
          className="h-5 mr-2 hidden md:block" 
        />
        <a
          href="/meet-us-in-ces-2025"
          
          // className="lg:text-center md:text-center text-left text-white lg:text-base text-xs font-sans underline"
          className="text-center text-black lg:text-base font-semibold font-sans underline"
        >
          Explore Innovative Technology Solutions at CES'25  #9542  North Hall  LVCC
          {/* Meet us at GITEX 2021 & transform your business digitally! */}
        </a>
        </div>
        {/* <a
          href="/meet-us-at-ces/"
          className="lg:ml-2 md:ml-2 ml-1 lg:px-2 md:px-2 px-1 py-1 bg-white lg:text-base text-xs text-blue-500 hover:text-blue-600 font-semibold font-sans rounded text-center"
          onClick={openGitexModal} 
        >
          Schedule Meeting
        </a> */}
      </div>
    </>
  )
}

export default StickyHeader
